/**
 * User categories ("I Am A") — admin-managed list.
 *
 * Hydrated from /api/user-categories.php (see services/userCategoriesApi.ts).
 * The list below is the offline / pre-migrate fallback and mirrors the seed in
 * migrate.php. Selects use the category NAME as the value (consistent with how
 * estimates.user_category + Pardot store it); slug is the stable admin key.
 */

export interface UserCategory {
  id: number | null;
  /** Display name, in the active language. */
  name: string;
  /** The English name — what forms submit and estimates.user_category stores. */
  nameEn: string;
  slug: string;
}

export const USER_CATEGORY_FALLBACK: UserCategory[] = [
  { id: null, name: 'Architect / Designer', nameEn: 'Architect / Designer',        slug: 'architect-designer' },
  { id: null, name: 'Building Materials Supplier', nameEn: 'Building Materials Supplier',  slug: 'building-materials-supplier' },
  { id: null, name: 'Contractor', nameEn: 'Contractor',                   slug: 'contractor' },
  { id: null, name: 'Professional Home Builder', nameEn: 'Professional Home Builder',    slug: 'professional-home-builder' },
  { id: null, name: 'Homeowner', nameEn: 'Homeowner',                    slug: 'homeowner' },
  { id: null, name: 'Business Owner', nameEn: 'Business Owner',               slug: 'business-owner' },
];
